/* 

About page

*/

import AboutPage from './AboutPage.jsx';

export default AboutPage;